import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSentry } from './lib/sentry';

// Sentry init runs once before React mounts. No-op when
// REACT_APP_SENTRY_DSN is unset; safe to land before an account exists.
initSentry();

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

const isLocalhost = typeof window !== 'undefined'
  && /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);

if ('serviceWorker' in navigator && !isLocalhost) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then((registration) => {
      const notify = (worker) => {
        if (!worker) return;
        // Only fire the "update available" event if there's already an
        // active controller — first-install transitions go straight to
        // controlling the page and don't need a user prompt.
        if (!navigator.serviceWorker.controller) return;
        worker.addEventListener('statechange', () => {
          if (worker.state === 'installed') {
            window.dispatchEvent(new CustomEvent('sw-update-available', {
              detail: { worker },
            }));
          }
        });
      };
      if (registration.waiting && navigator.serviceWorker.controller) {
        window.dispatchEvent(new CustomEvent('sw-update-available', {
          detail: { worker: registration.waiting },
        }));
      }
      registration.addEventListener('updatefound', () => notify(registration.installing));
    }).catch((err) => {
      console.warn('SW registration failed', err);
    });
  });

  // When the user accepts the update prompt, the new SW calls
  // skipWaiting() and the controllerchange fires here — reload once.
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  });
}
